import { createStore } from 'vuex';

export default createStore({
  state: {
    user: JSON.parse(sessionStorage.getItem('user')) || null,
    apps: JSON.parse(sessionStorage.getItem('apps')) || null,
    device: JSON.parse(sessionStorage.getItem('device')) || null,
    template: JSON.parse(sessionStorage.getItem('template')) || null
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      sessionStorage.setItem('user', JSON.stringify(user));
    },
    mergeUser(state, patch) {
      state.user = { ...state.user, ...patch };
      sessionStorage.setItem('user', JSON.stringify(state.user));
    },
    setApps(state, apps) {
      state.apps = apps;
      sessionStorage.setItem('apps', JSON.stringify(apps));
    },
    setDevice(state, device) {
      state.device = device;
      sessionStorage.setItem('device', JSON.stringify(device));
    },
    setTemplate(state, template) {
      state.template = template;
      sessionStorage.setItem('template', JSON.stringify(template));
    }
  },
  actions: {
    setUser({ commit }, user) {
      commit('setUser', user);
    },
    mergeUser({ commit }, patch) {
      commit('mergeUser', patch);
    },
    setApps({ commit }, apps) {
      commit('setApps', apps);
    },
    setDevice({ commit }, device) {
      commit('setDevice', device);
    },
    setTemplate({ commit }, template) {
      commit('setTemplate', template);
    }
  },
  getters: {
    getUser: (state) => state.user,
    getApps: (state) => state.apps,
    getDevice: (state) => state.device,
    getTemplate: (state) => state.template,
    // Permission checking helpers
    hasPermission: (state) => (permission) => {
      if (!state.user) return false;
      return state.user.role === 'admin' || 
             (state.user.permissions && state.user.permissions.includes(permission));
    },
    isAdmin: (state) => {
      return state.user && state.user.role === 'admin';
    }
  },
});